export default function NavLinkDirective() {
  return {
    scope: {
      url: '=',
      text: '=',
      disabled: '=',
      target: '@'
    },
    restrict: 'E',
    template: `<a ng-class="{ disabled: disabled }" target="{{ target ? target : '_self'}}" ng-href="{{ disabled ? '' : url }}" ng-bind-html="text"></a>`
  };
}
